/* eslint-disable max-len */
import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  BULKTRANSFER,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchBulkTransfer = async (searchParams) => {
  const { payload } = searchParams;
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.searchParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_FUNDINGSOURCE}?contact.name.LIKE=${payload.searchParams}&contact.contactType.NE=SELF`);
  }
  if (payload.searchParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_FUNDINGSOURCE}${query}${sorting}&contact.name.LIKE=${payload.searchParams}&contact.contactType.NE=SELF`);
  }
  if (!payload.searchParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_FUNDINGSOURCE}${query}${sorting}&contact.contactType.NE=SELF`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_FUNDINGSOURCE}${query}${sorting}&contact.contactType.NE=SELF`);
};

const fetchBulkTransferSearch = async (searchParams) => {
  const { payload } = searchParams;
  return axiosAuthInstance.get(`${API_END_POINTS.GET_FUNDINGSOURCE}?contact.name.LIKE=${payload.searchParams}&contact.contactType.NE=SELF`);
};

const postBulkTransfer = async payload => axiosAuthInstance.post(API_END_POINTS.MULTI_TRANSFER, payload);

export function* getBulkTransfer(action) {
  try {
    const { data: { entity } } = yield call(fetchBulkTransfer, action.payload);
    yield put({ type: BULKTRANSFER.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: BULKTRANSFER.FAILED, payload: e.response.data });
  }
}

export function* getBulkTransferSearch(action) {
  try {
    const { data: { entity } } = yield call(fetchBulkTransferSearch, action.payload);
    yield put({ type: BULKTRANSFER.SUCCESS_SEARCH, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: BULKTRANSFER.FAILED, payload: e.response.data });
  }
}

export function* addBulkTransfer(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postBulkTransfer, action.payload);
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.BULKTRANSFER.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      if (e?.response?.data) {
        yield put({
          type: NOTIFICATION.ERROR,
          payload: 'Unable to process the request',
        });
      } else {
        yield put({
          type: NOTIFICATION.ERROR,
          payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
        });
      }
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
